import { render, staticRenderFns } from "./QuickLogin.vue?vue&type=template&id=8202221a&scoped=true&"
import script from "./QuickLogin.vue?vue&type=script&lang=js&"
export * from "./QuickLogin.vue?vue&type=script&lang=js&"
import style0 from "./QuickLogin.vue?vue&type=style&index=0&id=8202221a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8202221a",
  null
  
)

export default component.exports